"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDisputeLastStatus = void 0;
exports.OrderDisputeLastStatus = {
    WarningNeedsResponse: "warning_needs_response",
    WarningUnderReview: "warning_under_review",
    WarningClosed: "warning_closed",
    NeedsResponse: "needs_response",
    UnderReview: "under_review",
    ChargeRefunded: "charge_refunded",
    Won: "won",
    Lost: "lost",
};
